import React from "react";
import $ from "jquery";
import Loader from "../../UI/loader";
import Result from "./Result";
import { connect } from "react-redux";
import { sendAnalytics } from "../../../action/homeAction"
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import { getClearCredentials, validateClearVerification } from "../../../action/clearVerification";
import { setCardChecksData } from "../../../action/action";



const ClearVerificationWeb = (props) => {

    let localCardChecksData = props.cardChecksData;
    let randNum = Math.floor(Math.random() * 100000) + 1;
    const [error, setError] = React.useState(false)
    const [errorMsg, setErrorMsg] = React.useState("")
    const [showLoader, setShowLoader] = React.useState(false)
    const [enableClear, setEnableClear] = React.useState(false)
    const [askCameraPermission, setAskCameraPermission] = React.useState(false)
    const [clearCredentials, setClearCredentials] = React.useState({})
    let label = getDefaultAnalyticsLabel({ appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : "" })


    const updatedCardData = () => {

        if (props.cardChecksData.guestValidationMaxRetry) {
            localCardChecksData.guestValidationMaxRetry = +props.cardChecksData.guestValidationMaxRetry - 1;
        }
        console.log(localCardChecksData)
        setCardChecksData(localCardChecksData)
        return true;
    }

    const handleClearResponse = (response, status) => {

        console.log(" Response from CLEAR " + JSON.stringify(response))

        setEnableClear(false)
        setShowLoader(true)
        updatedCardData();

        if (status) {
            try {

                validateClearVerification(response.code, props.confirmationNumber)
                    .then((res) => {

                        if (res.status == 200) {
                            setShowLoader(false)
                            props.handleCLEARData(res.data.payload)
                            props.setNextScreen();

                            props.sendAnalytics(
                                null, // as no guesdetails in logout state 
                                props.currentWidgetObj.widgetType || "Mobile Check-in",
                                "CLEAR ID VERIFICATION - SUCCESS",
                                { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "pageName": "CLEAR ID VERIFICATION", "widgetSessionId": localStorage.getItem("checkinSessionToken") },
                                0,
                                false // guest as not logged in
                            )
                        } else {
                            setShowLoader(false)
                            setError(true)
                            setErrorMsg(res.response.data.header.status.msg)

                            props.sendAnalytics(
                                null, // as no guesdetails in logout state 
                                props.currentWidgetObj.widgetType || "Mobile Check-in",
                                "CLEAR ID VERIFICATION - FAILED",
                                { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "pageName": "CLEAR ID VERIFICATION", "widgetSessionId": localStorage.getItem("checkinSessionToken"), "errorMessage": res.response.data.header.status.msg },
                                0,
                                false // guest as not logged in
                            )
                        }
                    })
                    .catch((err) => {
                        setShowLoader(false)
                        setError(true)
                    })
            } catch (error) {
                setShowLoader(false)
                setError(true)

                props.sendAnalytics(
                    null, // as no guesdetails in logout state 
                    props.currentWidgetObj.widgetType || "Mobile Check-in",
                    "CLEAR ID VERIFICATION - FAILED",
                    { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "pageName": "CLEAR ID VERIFICATION", "widgetSessionId": localStorage.getItem("checkinSessionToken"), "errorMessage": "something went wrong in CLEAR details validation call" },
                    0,
                    false // guest as not logged in
                )
            }
        } else {
            setEnableClear(false)
            setShowLoader(false)
            setError(true)
            setErrorMsg(response.error_description)

            props.sendAnalytics(
                null, // as no guesdetails in logout state 
                props.currentWidgetObj.widgetType || "Mobile Check-in",
                "CLEAR ID VERIFICATION - FAILED",
                { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "pageName": "CLEAR ID VERIFICATION", "widgetSessionId": localStorage.getItem("checkinSessionToken"), "errorMessage": response.error_description },
                0,
                false // guest as not logged in
            )
        }
    }

    const enableInAppBrowser = () => {

        setEnableClear(false)
        const checkInGuestPreInfo = {
            lastName: props.lastName ,
            bookingNumber: props.confirmationNumber,
            checkinDate: props.checkinDate
        }

        localStorage.setItem("checkInGuestPreInfo", JSON.stringify(checkInGuestPreInfo));

        let clearURL;

        if(clearCredentials.clearDemo){
            clearURL = `https://verify.partner.platform.clearme.com/?clientId=${clearCredentials.clientId}&useCase=${clearCredentials.useCase}&redirectURI=${clearCredentials.redirectURI}&state=${clearCredentials.stateWeb + "_web_" + randNum}&scope=${clearCredentials.scope.join('+')}`;
        } else {
            clearURL = `https://verify.clearme.com/?clientId=${clearCredentials.clientId}&useCase=${clearCredentials.useCase}&redirectURI=${clearCredentials.redirectURI}&state=${clearCredentials.stateWeb + "_web_" + randNum}&scope=${clearCredentials.scope.join('+')}`;
        }
        window.open(clearURL, '_top');

        setTimeout(() => {
            setShowLoader(false);
            setError(true);
        }, 2500);

        // window.setInterval(function() {
        //     authWindow.close();

        //     if (authWindow.closed) {
        //       console.log("this is what we are looking")
        //     }
        //   }, 5000)
    }

    const successCameraPermission = () => {
        console.log("in success Camera Permission")

        setError(false)
        setShowLoader(true)

        getClearCredentials()
            .then((res) => {
                if (res.status == 200) {
                    setClearCredentials(res.data.payload)
                    setEnableClear(true)
                } else {
                    setShowLoader(false)
                    setError(true)
                    setErrorMsg(res.response.data.header.status.msg)

                    props.sendAnalytics(
                        null, // as no guesdetails in logout state 
                        props.currentWidgetObj.widgetType || "Mobile Check-in",
                        "CLEAR ID VERIFICATION - FAILED",
                        { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "pageName": "CLEAR ID VERIFICATION", "widgetSessionId": localStorage.getItem("checkinSessionToken"), "errorMessage": res.response.data.header.status.msg },
                        0,
                        false // guest as not logged in
                    )
                }
            })
            .catch((err) => {
                setShowLoader(false)
                setError(true)
            })

    }

    React.useEffect(() => {

        if(sessionStorage.getItem("clearWebVerification")){
            console.log("CLEAR POST CALL")
            const clearWebVerification = JSON.parse( sessionStorage.getItem("clearWebVerification"))
            handleClearResponse({ code: clearWebVerification.checkInClearToken, error_description: clearWebVerification.error_description}, clearWebVerification.success)

            sessionStorage.removeItem("clearWebVerification")
        } else {
            successCameraPermission()
        }
    }, [askCameraPermission])


    React.useEffect(() => {
        if (enableClear) {
            if (Object.keys(clearCredentials).length > 0) {
                enableInAppBrowser();
            }
        }
    }, [enableClear])


    return (
        <div className="clear-container" >
            {enableClear ? null :
                showLoader ? <Loader close={() => this.setState({ showLoader: false })} displayMsg="Fetching Data..." /> :
                    error ? <Result backBtn={props.goBack} tryAgain={() => { setAskCameraPermission(!askCameraPermission) }} heading="Mobile Check-in" page="clear" success={false}
                        ga_error_message={localCardChecksData.guestValidationMaxRetry == 0 ? errorMsg ? errorMsg : "Something Went Wrong" : errorMsg ? errorMsg + " Please contact Front Desk or try again." : "Something Went Wrong. Please contact Front Desk or try again."}
                        message={localCardChecksData.guestValidationMaxRetry == 0 ? errorMsg ? errorMsg : "Something Went Wrong" : errorMsg ? errorMsg + " Please contact Front Desk or try again." : "Something Went Wrong. Please contact Front Desk or try again."} />
                        : null}
        </div>
    )
}

const mapStateToProps = state => {
    return {
        currentHomePage: state.store2.currentHomePage,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        cardChecksData: state.store2.cardChecksData,
    }
}

export default connect(mapStateToProps, { setCardChecksData, sendAnalytics })(ClearVerificationWeb);